import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { ROUTES } from '~router/routePaths';

const MESSAGES_PATH = `/${ROUTES.messages}`;

export default function useMessagingConversationNavigation() {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();

  const isOnMessagesPage =
    pathname === MESSAGES_PATH || pathname.startsWith(`${MESSAGES_PATH}/`);
  // The Messages page keeps its list view in the query string; another page's query is not ours.
  const listViewSearch = isOnMessagesPage ? search : '';

  const openConversation = useCallback(
    (channelId: string) =>
      navigate({ pathname: `${MESSAGES_PATH}/${channelId}`, search: listViewSearch }),
    [listViewSearch, navigate],
  );

  const openConversationList = useCallback(
    () => navigate({ pathname: MESSAGES_PATH, search: listViewSearch }),
    [listViewSearch, navigate],
  );

  return { openConversation, openConversationList };
}
